// extracted by mini-css-extract-plugin
export var subtitle = "_cb-2";
export var title = "_cb-0";
export var titleNoWrap = "_cb-1";